'use client';

import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from './ui/dropdown-menu';
import React, { useCallback, useState } from 'react';
import Link from 'next/link';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';
import {
  BarChart3,
  Book,
  Bookmark,
  Clock,
  Info,
  LayoutList,
  LogIn,
  LogOut,
  MessageSquarePlus,
  ShieldQuestion,
  User,
  UserRound,
} from 'lucide-react';
import { createBrowserClientSupa } from '@/utils/supabase/createBrowserClient';
import { useGetSupabaseSession } from '@/hooks/useGetSupabaseSession';

const UserMenu = () => {
  const supabase = createBrowserClientSupa();
  const session = useGetSupabaseSession();
  const user = session?.user;
  const [isOpen, setIsOpen] = useState(false);

  const signOut = useCallback(async () => {
    await supabase.auth.signOut();
    window.location.reload();
  }, [supabase.auth]);

  const handleItemClick = useCallback(() => {
    setIsOpen(false);
  }, []);

  const userData = user?.user_metadata;
  const avatarUrl = userData?.avatar_url;

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Avatar className="size-8 cursor-pointer hover:opacity-80 sm:size-10">
          <AvatarImage src={avatarUrl} alt="User avatar" />
          <AvatarFallback>
            <UserRound />
          </AvatarFallback>
        </Avatar>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="mr-2 w-40">
        <DropdownMenuItem className="block sm:hidden" onClick={handleItemClick}>
          <Link href="/" className="flex items-center space-x-2">
            <LayoutList size={14} />
            <span>List</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="block sm:hidden" onClick={handleItemClick}>
          <Link href="/cheatsheet" className="flex items-center space-x-2">
            <Bookmark size={14} />
            <span>Cheatsheet</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleItemClick} className="block sm:hidden">
          <Link href="/review" className="flex items-center space-x-2">
            <Clock size={14} />
            <span>Review</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="block md:hidden" onClick={handleItemClick}>
          <Link href="/quiz" className="flex items-center space-x-2">
            <ShieldQuestion size={14} />
            <span>Quiz</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="lg:hidden" onClick={handleItemClick}>
          <Link href="/stats" className="flex items-center space-x-2">
            <BarChart3 size={14} />
            <span>Stats</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="" onClick={handleItemClick}>
          <Link href="/account" className="flex items-center space-x-2">
            <User size={14} />
            <span>Account</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="" onClick={handleItemClick}>
          <Link href="/manual" className="flex items-center space-x-2">
            <Book size={14} />
            <span>Git Manual</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem className="" onClick={handleItemClick}>
          <Link href="/about" className="flex items-center space-x-2">
            <Info size={14} />
            <span>About</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleItemClick}>
          <Link href="/feedback" className="flex items-center space-x-2">
            <MessageSquarePlus size={14} />
            <span>Feedback</span>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleItemClick}>
          <Link href="/login" className="flex items-center space-x-2">
            <LogIn size={14} />
            <span>Login</span>
          </Link>
        </DropdownMenuItem>
        {user && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={handleItemClick}>
              <div className="flex items-center space-x-2" onClick={signOut}>
                <LogOut size={14} />
                <span>Log Out</span>
              </div>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UserMenu;
